import styled from 'styled-components';
import {
  Row,
  Ellipse as DefaultEllipse,
  Analysis as DefaultAnalysis,
} from '~components';

export const Container = styled.div`
  align-items: center;
  display: flex;
  height: calc(100vh - 105px);
  justify-content: center;
  width: auto;
`;

export const Ellipse = styled(DefaultEllipse)`
  margin: auto;
  display: block;
  animation: rotation 2s infinite linear;

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`;

export const Analysis = styled(DefaultAnalysis)`
  margin: auto;
  margin-top: -125px;
  display: block;
`;

export const LoadingWrapper = styled.div`
  display: grid;
  justify-content: center;
  justify-items: center;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpoint.md.maxWidth}) {
    height: 192px;
  }
`;
